<div class="filter-container responsive-filters">
  <mat-form-field appearance="outline" class="filter-input">
    <mat-label>{{ 'Kërko lajmin' | translate }}</mat-label>
    <input (keyup.enter)="applyFilter()" [(ngModel)]="filterTitle" matInput >
  </mat-form-field>

  <button style="margin-bottom: 1.3rem" mat-raised-button color="primary" (click)="applyFilter()" class="filter-btn">
    {{ 'Apply Filter' | translate }}
  </button>

  <button style="margin-bottom: 1.3rem" mat-raised-button color="secondary" (click)="clearFilter()" class="filter-btn">
    {{ 'Clear' | translate }}
  </button>

  <button style="margin-bottom: 1.3rem" mat-raised-button color="primary" (click)="addNews()" class="create-btn">
    {{ 'Create News' | translate }}
  </button>
</div>

<div class="table-responsive">
  <table [dataSource]="news" class="mat-elevation-z8" mat-table>
    <ng-container matColumnDef="title">
      <th *matHeaderCellDef mat-header-cell> {{ 'Titulli' | translate }}</th>
      <td *matCellDef="let aNew" mat-cell>{{ aNew.alTitle | truncate:50 }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th *matHeaderCellDef mat-header-cell> {{ 'Statusi' | translate }}</th>
      <td *matCellDef="let aNew" mat-cell>{{ aNew.status | truncate:100 }}</td>
    </ng-container>

    <ng-container matColumnDef="open">
      <th *matHeaderCellDef mat-header-cell> {{ 'Edit' | translate }}</th>
      <td *matCellDef="let aNew" mat-cell>
        <a [routerLink]="['/admin-panel/admin-news', aNew.id]"
           style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
          <i class="fa fa-edit"></i>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="remove">
      <th *matHeaderCellDef mat-header-cell> {{ 'Remove' | translate }}</th>
      <td *matCellDef="let aNew" mat-cell>
        <a (click)="deleteNews(aNew.id)" style="cursor: pointer; color: red; font-size: 18px; margin-left: 1rem;">
          <i class="fa fa-remove"></i>
        </a>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
  </table>
</div>

<mat-paginator (page)="onPageChange($event)" [length]="totalItems" [pageSize]="pageSize"></mat-paginator>
